import { postContacts } from "@repository/contactsRepository";
import { useMutation } from "react-query";

const usePostContacts = (lang: string) => {
  const mutation = useMutation((data: void) => {
    return postContacts(data, lang);
  });

  const { mutate, isLoading, isError, data, error }: any = mutation;
  return {
    mutate,
    isLoading,
    isError,
    data,
    errorMessage: error?.response.data,
  };
};

export default usePostContacts;
